import api from '../api/api'

const FETCH_LEADERBOARD = 'LOYALTY/FETCH_LEADERBOARD'
const SET_ANALYTICS = 'LOYALTY/SET_ANALYTICS'
const FETCH_SETTINGS = 'LOYALTY/FETCH_SETTINGS'
const UPDATE_SETTINGS = 'LOYALTY/UPDATE_SETTINGS'
const FETCH_ACTIVITIES = 'LOYALTY/FETCH_ACTIVITIES'
const UPDATE_ACTIVITY = 'LOYALTY/UPDATE_ACTIVITY'
const DELETE_ACTIVITY = 'LOYALTY/DELETE_ACTIVITY'
const FETCH_DASHBOARD = 'LOYALTY/FETCH_DASHBOARD'
const CANCEL_ACTIVITY_POINTS = 'LOYALTY/CANCEL_ACTIVITY_POINTS'
const UPDATE_DASHBOARD = 'LOYALTY/UPDATE_DASHBOARD'
const FETCH_REWARDS = 'LOYALTY/FETCH_REWARDS'
const UPDATE_REWARD = 'LOYALTY/UPDATE_REWARD'

const initialState = {
  leaderboard: [],
  activities: [],
  dashboard: [],
  rewards: [],
  analytics: null,
  settings: null,
}

const loyaltyReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LEADERBOARD: {
      return {
        ...state,
        leaderboard: action.data,
      }
    }
    case SET_ANALYTICS: {
      return {
        ...state,
        analytics: action.analytics,
      }
    }
    case FETCH_SETTINGS: {
      return {
        ...state,
        settings: action.settings,
      }
    }
    case UPDATE_SETTINGS: {
      return {
        ...state,
        settings: {
          ...state.settings,
          ...action.data,
        },
      }
    }
    case FETCH_ACTIVITIES: {
      return {
        ...state,
        activities: action.activities,
      }
    }
    case UPDATE_ACTIVITY: {
      const updatedActivities = state.activities.map((activity) => {
        if (activity.id === action.activity.id) {
          activity = { ...activity, ...action.activity }
        }
        return activity
      })
      return {
        ...state,
        activities: updatedActivities,
      }
    }
    case DELETE_ACTIVITY: {
      const filteredActivities = state.activities.filter(
        (activity) => activity.id !== action.activityId,
      )

      return {
        ...state,
        activities: filteredActivities,
      }
    }
    case FETCH_DASHBOARD: {
      return {
        ...state,
        dashboard: action.dashboard,
      }
    }
    case CANCEL_ACTIVITY_POINTS: {
      const { earnRecord, canceledRecord } = action.data
      const index = state.dashboard.findIndex((activity) => activity.id === earnRecord.id)
      if (index === -1) return state
      const updatedDashboard = [...state.dashboard]
      updatedDashboard[index] = earnRecord
      updatedDashboard.splice(index, 0, canceledRecord)
      return {
        ...state,
        dashboard: updatedDashboard,
      }
    }
    case UPDATE_DASHBOARD: {
      const updatedDashboard = state.dashboard.map((activity) => {
        if (activity.id === action.data.id) {
          activity = { ...activity, ...action.data }
        }
        return activity
      })
      return {
        ...state,
        dashboard: updatedDashboard,
      }
    }
    case FETCH_REWARDS: {
      return {
        ...state,
        rewards: action.rewards,
      }
    }
    case UPDATE_REWARD: {
      const updatedRewards = state.rewards.map((reward) => {
        if (reward.id === action.reward.id) {
          reward = { ...reward, ...action.reward }
        }
        return reward
      })
      return {
        ...state,
        rewards: updatedRewards,
      }
    }
    default:
      return state
  }
}

export const fetchLoyaltyLeaderboard =
  ({ buildingId, page = 1, limit = 50, query, startDate, endDate }) =>
  (dispatch) => {
    const skip = (page - 1) * limit
    return api
      .fetchLoyaltyLeaderboard(buildingId, { skip, search: query, limit, startDate, endDate })
      .then((res) => {
        dispatch({ type: FETCH_LEADERBOARD, data: res.data.data })
        return Promise.resolve(res.data.total)
      })
      .catch((err) => Promise.reject(err))
  }

export const fetchLoyaltyAnalytics =
  ({ buildingId, startDate, endDate }) =>
  (dispatch) => {
    return api
      .fetchLoyaltyAnalytics(buildingId, { startDate, endDate })
      .then((res) => {
        dispatch({ type: SET_ANALYTICS, analytics: res.data })
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  }

export const fetchLoyaltySettings = (buildingId) => (dispatch) => {
  return api
    .fetchLoyaltySettings(buildingId)
    .then((res) => {
      dispatch({ type: FETCH_SETTINGS, settings: res.data })
      return Promise.resolve(res.data)
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

export const updateLoyaltySettings = (buildingId, params) => (dispatch) => {
  return api
    .updateLoyaltySetting(buildingId, params)
    .then((res) => {
      dispatch({ type: UPDATE_SETTINGS, data: params })
      return Promise.resolve(res.data)
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

export const fetchBuildingActivities = (buildingId) => (dispatch) => {
  return api
    .fetchLoyaltyBuildingActivities(buildingId)
    .then((res) => {
      dispatch({ type: FETCH_ACTIVITIES, activities: res.data })
      return Promise.resolve(res.data)
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

export const updateBuildingActivityStatus =
  (activityId, { isActive, isFeatured, expirationDate }) =>
  (dispatch) => {
    return api
      .updateLoyaltyBuildingActivityStatus(activityId, { isActive, isFeatured, expirationDate })
      .then((res) => {
        dispatch({ type: UPDATE_ACTIVITY, activity: res.data })
        return Promise.resolve(res.data)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  }

export const deleteBuildingActivity = (activityId) => (dispatch) => {
  return api
    .deleteLoyaltyBuildingActivity(activityId)
    .then(() => {
      dispatch({ type: DELETE_ACTIVITY, activityId })
      return Promise.resolve()
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

export const updateBuildingActivity = (activityId, params) => (dispatch) => {
  return api
    .updateLoyaltyBuildingActivity(activityId, params)
    .then(() => {
      dispatch({ type: UPDATE_ACTIVITY, activity: { id: activityId, ...params } })
      return Promise.resolve()
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

export const fetchLoyaltyDashboard =
  ({ buildingId, page = 1, limit = 50, query, type }) =>
  (dispatch) => {
    const skip = (page - 1) * limit
    return api
      .fetchLoyaltyDashboard(buildingId, { skip, search: query, limit, type })
      .then((res) => {
        dispatch({ type: FETCH_DASHBOARD, dashboard: res.data.activities })
        return Promise.resolve(res.data.total)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  }

export const cancelDashboardActivityPoints = (activityId) => (dispatch) => {
  return api
    .loyaltyActivityCancelPoints(activityId)
    .then((res) => {
      dispatch({ type: CANCEL_ACTIVITY_POINTS, data: res.data })
      return Promise.resolve(res.data)
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

export const declineDashboardActivity = (activityId) => (dispatch) => {
  return api
    .loyaltyDeclineActivity(activityId)
    .then((res) => {
      dispatch({ type: UPDATE_DASHBOARD, data: res.data })
      return Promise.resolve(res.data)
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

export const approveDashboardActivity = (activityId) => (dispatch) => {
  return api
    .loyaltyApproveActivity(activityId)
    .then((res) => {
      dispatch({ type: UPDATE_DASHBOARD, data: res.data })
      return Promise.resolve(res.data)
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

export const fetchLoyaltyBuildingRewards =
  ({ buildingId, page = 1, limit = 50, name, type }) =>
  (dispatch) => {
    const skip = (page - 1) * limit
    return api
      .fetchLoyaltyBuildingRewards(buildingId, { skip, limit, name, type })
      .then((res) => {
        dispatch({ type: FETCH_REWARDS, rewards: res.data.data })
        return Promise.resolve(res.data.total)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  }

export const updateBuildingRewardStatus = (rewardId, isActive) => (dispatch) => {
  return api
    .updateLoyaltyBuildingRewardStatus(rewardId, { isActive })
    .then((res) => {
      dispatch({ type: UPDATE_REWARD, reward: res.data })
      return Promise.resolve(res.data)
    })
    .catch((err) => {
      return Promise.reject(err)
    })
}

export const selectLeaderboard = (state) => state.loyalty.leaderboard

export const selectLoyaltyAnalytics = (state) => state.loyalty.analytics

export const selectLoyaltySettings = (state) => state.loyalty.settings

export const selectBuildingActivities = (state) => state.loyalty.activities

export const selectLoyaltyDashboard = (state) => state.loyalty.dashboard

export const selectLoyaltyRewards = (state) => state.loyalty.rewards

export default loyaltyReducer
